import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit(): void {
  }

  navigateTo(route: string): void {
    // console.log('🔗 Navegando a:', route);
    // console.log('🌐 URL completa será:', window.location.origin + '/#' + route);
    this.router.navigate([route]).then(success => {
      // console.log('✅ Navegación exitosa:', success);
    }).catch(error => {
      console.error('❌ Error en navegación:', error);
    });
  }

}
